import React from "react";
import { SidebarIcons } from "../StandardContentSidebar/SidebarIcons";
import PropTypes from "prop-types";

const adminHrmenus = [
  {
    id: 18,
    label: "Employee Management",
    type: "collapsible",
    icon: SidebarIcons.EmployeeManagementIcon,
    children: [
      {
        id: 258,
        uri: "/hr/list-employee",
        label: "Employee Profile",
        type: "nav-item",
        icon: SidebarIcons.EmployeeMasterIcon,
      },
      {
        id: 254,
        uri: "/hr/HrOperation/EmployeeOrganisation/EmployeeOrg",
        label: "Employee Organization",
        type: "nav-item",
        icon: SidebarIcons.EmployeeOrganizationIcon,
      },
    ],
  },

  {
    id: 18,
    label: "Time Management",
    type: "collapsible",
    icon: SidebarIcons.TimeManagementIcon,
    children: [
      {
        label: "Attendance Through Device",
        type: "collapsible",
        icon: SidebarIcons.DeviceAttendanceIcon,
        children: [
          {
            id: 266,
            uri: "/hr/HrOperation/DeviceConfiguration",
            label: "Biometric Configuration",
            type: "nav-item",
            icon: SidebarIcons.DeviceConfigurationIcon,
          },
          {
            id: 266,
            uri: "/hr/HrOperation/Checkinlists",
            label: "Import Attendance",
            type: "nav-item",
            icon: SidebarIcons.ImportAttendanceIcon,
          },
        ],
      },

      {
        id: 61,
        uri: "/hr/CheckinlistsESS",
        label: "Attendance From ESS",
        type: "nav-item",
        icon: SidebarIcons.ESSAttendanceIcon,
      },

      {
        id: 62,
        label: "Attendance From Timesheet",
        type: "nav-item",
        uri: "/hr/list-time-management",
        icon: SidebarIcons.TimesheetAttendanceIcon,
        // children: [
        //   {
        //     id: 62,
        //     uri: "/hr/list-time-management",
        //     label: "Timesheet",
        //     type: "nav-item",
        //     icon: SidebarIcons.TimesheetIcon,
        //   },
        //   {
        //     id: 249,
        //     uri: "/hr/process-attendance",
        //     label: "Create Attendance",
        //     type: "nav-item",
        //     icon: SidebarIcons.CreateAttendanceIcon,
        //   },
        // ],
      },

      {
        id: 61,
        uri: "/hr/HrOperation/CheckinStatus",
        label: "Check-In Status",
        type: "nav-item",
        icon: SidebarIcons.CheckInStatusIcon,
      },

      {
        id: 61,
        uri: "/hr/AbsentEmployees",
        label: "Absent Employees",
        type: "nav-item",
        icon: SidebarIcons.AbsentEmployeesIcon,
      },
      {
        id:61,
        uri: "/hr/LateCheckinEmployees",
        label: "Late Check-in Employees",
        type: "nav-item",
        icon: SidebarIcons.LateCheckinIcon,
      },
      {
        id: 62,
        uri: "/hr/timesheet-logs",
        label: "Timesheet Logs",
        type: "nav-item",
        icon: SidebarIcons.TimesheetAttendanceIcon,
      },

      {
        id: 185,
        uri: "/hr/create-attendance",
        // uri: "/hr/process-attendance",
        label: "Create Attendance",
        type: "nav-item",
        icon: SidebarIcons.CreateAttendanceIcon,
      },

      {
        id: 267,
        uri: "/hr/process-attendance",
        // uri: "/hr/create-attendance",
        // label: "Process Attendance",
        label: "Attendance Logs",
        type: "nav-item",
        icon: SidebarIcons.ProcessAttendanceIcon,
      },
    ],
  },

  {
    id: 18,
    label: "Leave Management",
    type: "collapsible",
    icon: SidebarIcons.LeaveManagementIcon,
    children: [
      {
        id: 29,
        uri: "/hr/list-leave-type",
        label: "Leave Type",
        type: "nav-item",
        icon: SidebarIcons.LeaveTypeIcon,
      },
      {
        id: 247,
        uri: "/hr/list-leave-balance",
        label: "Leave Opening Balance",
        type: "nav-item",
        icon: SidebarIcons.LeaveBalanceIcon,
      },
      {
        id: 26,
        uri: "/hr/list-of-leaves",
        label: "Leave Position",
        type: "nav-item",
        icon: SidebarIcons.LeavePositionIcon,
      },
      {
        id: 37,
        uri: "/hr/list-of-leave-calendar",
        label: "Leave Calendar",
        type: "nav-item",
        icon: SidebarIcons.LeaveCalendarIcon,
      },
      {
        id: 27,
        uri: "/hr/list-leave-cancellation",
        label: "Leave Cancellation",
        type: "nav-item",
        icon: SidebarIcons.LeaveCancellationIcon,
      },
    ],
  },

  {
    id: 18,
    label: "Payroll Management",
    type: "collapsible",
    icon: SidebarIcons.PayrollManagementIcon,
    children: [
      {
        label: "Settings",
        type: "collapsible",
        icon: SidebarIcons.PayrollSettingIcon,
        children: [
          {
            id: 39,
            uri: "/hr-settings",
            label: "Pay Calendar",
            type: "nav-item",
            icon: SidebarIcons.PaySetupIcon,
          },
          {
            id: 38,
            uri: "/hr-payroll-settings",
            label: "Payroll Calendar",
            type: "nav-item",
            icon: SidebarIcons.PayrollCalendarIcon,
          },
          {
            id: 184,
            uri: "/hr/configuration-payroll",
            label: "Payroll Configuration",
            type: "nav-item",
            icon: SidebarIcons.PayConfigurationIcon,
          },
          {
            label: "Statutory Components",
            type: "collapsible",
            // icon: (
            //   <SiWebcomponentsdotorg
            //     style={{ fontSize: 17, marginLeft: 30, marginRight: 15 }}
            //     data-toggle="tooltip"
            //     data-placement="bottom"
            //     title="Statutory Components"
            //   />
            // ),
            icon: SidebarIcons.StatutoryIcon,
            children: [
              {
                id: 261,
                uri: "/hr/employee-provident-fund",
                label: "Employee Provident Fund",
                type: "nav-item",
                icon: SidebarIcons.ProvidentFundIcon,
              },
              {
                id: 257,
                uri: "/hr/employee-state-insurance",
                label: "Employee State Insurance",
                type: "nav-item",
                icon: SidebarIcons.ESIIcon,
              },
              {
                id: 260,
                uri: "/hr/professional-tax",
                label: "Professional Tax",
                type: "nav-item",
                icon: SidebarIcons.ProfessionalTaxIcon,
              },
            ],
          },
          {
            label: "Salary Component",
            type: "collapsible",
            icon: SidebarIcons.SalaryComponentIcon,
            children: [
              {
                id: 256,
                uri: "/hr/salary-earnings",
                label: "Earnings",
                type: "nav-item",
                icon: SidebarIcons.EarningsIcon,
              },
              {
                id: 255,
                uri: "/hr/salary-deductions",
                label: "Deductions",
                type: "nav-item",
                icon: SidebarIcons.DeductionsIcon,
              },
            ],
          },
        ],
      },

      // {
      //   id: 185,
      //   uri: "/hr/create-attendance",
      //   label: "Process Attendance",
      //   type: "nav-item",
      //   icon: (
      //     <MdPlaylistAdd
      //       style={{ fontSize: 14, marginLeft: 15 }}
      //       data-toggle="tooltip"
      //       data-placement="bottom"
      //       title="View & Approve Attendance"
      //     />
      //   ),
      // },
      {
        id: 186,
        uri: "/hr/payroll-data-processing",
        label: "Create Payroll",
        type: "nav-item",
        icon: SidebarIcons.CreatePayrollIcon,
      },

      // Reversal components
      {
        id: 187,
        uri: "/hr/EarningsVariable",
        label: "Variable Earning",
        type: "nav-item",
        icon: SidebarIcons.VariableEarningIcon,
      },
      {
        id: 188,
        uri: "/hr/DeductionVariable",
        label: "Variable Deduction",
        type: "nav-item",
        icon: SidebarIcons.VariableDeductionIcon,
      },
      {
        id: 189,
        uri: "/hr/ReversalLOP",
        label: "Reversal LOP",
        type: "nav-item",
        icon: SidebarIcons.ReverseLopIcon,
      },
      {
        id: 190,
        uri: "/hr/draft-payroll",
        label: "Process Payroll",
        type: "nav-item",
        icon: SidebarIcons.ProcessPayrollIcon,
      },
      {
        id: 191,
        uri: "/hr/payslip-summary",
        label: "Payslip Summary",
        type: "nav-item",
        icon: SidebarIcons.PayslipSummaryIcon,
      },
      {
        id: 259,
        uri: "/hr/payslip",
        label: "Generate Payslip",
        type: "nav-item",
        icon: SidebarIcons.PayslipsIcon,
      },
      {
        id: 192,
        uri: "/hr/pay-voucher",
        label: "Payroll Journal Generation",
        type: "nav-item",
        icon: SidebarIcons.PayrollJournalsIcon,
      },
    ],
  },

  {
    id: 18,
    label: "Income Tax",
    type: "collapsible",
    icon: SidebarIcons.IncomeTaxIcon,
    children: [
      {
        id: 268,
        uri: "/hr/Taxslab-configuration",
        label: "IT Slab Setup",
        type: "nav-item",
        icon: SidebarIcons.TaxSlabIcon,
      },
      {
        id: 269,
        uri: "/hr/Tax-Section",
        label: "IT Section",
        type: "nav-item",
        icon: SidebarIcons.TaxSectionIcon,
      },
      {
        id: 270,
        uri: "/hr/Tax-Exemptions",
        label: "IT Exemptions",
        type: "nav-item",
        icon: SidebarIcons.TaxExemptionIcon,
      },
      {
        id: 271,
        uri: "/hr/Tax-Deductions",
        label: "IT Deductions",
        type: "nav-item",
        icon: SidebarIcons.TaxDeductionIcon,
      },
      {
        id: 272,
        uri: "/hr/Tax-Declaration",
        label: "IT Declaration",
        type: "nav-item",
        icon: SidebarIcons.TaxDeclarationIcon,
      },
      {
        id: 273,
        uri: "/hr/Tax-Calculation",
        label: "Tax Calculation",
        type: "nav-item",
        icon: SidebarIcons.TaxCalculationIcon,
      },
    ],
  },

  {
    id: 18,
    label: "Appraisal",
    type: "collapsible",
    icon: SidebarIcons.AppraisalIcon,
    children: [
      {
        id: 274,
        uri: "/hr/Goal-List",
        label: "Goals",
        type: "nav-item",
        icon: SidebarIcons.GoalsIcon,
      },
      {
        id: 275,
        uri: "/hr/KPI",
        label: "KPI",
        type: "nav-item",
        icon: SidebarIcons.KpiIcon,
      },
      {
        id: 276,
        uri: "/hr/Setting-up-Goal",
        label: "Setting Up Goal",
        type: "nav-item",
        icon: SidebarIcons.GoalSettingsIcon,
      },
      {
        id: 277,
        uri: "/hr/apprisal",
        label: "Appraisal",
        type: "nav-item",
        icon: SidebarIcons.PerformanceAppraisalIcon,
      },
      {
        id: 278,
        uri: "/hr/final-evaluation",
        label: "Final Evaluation",
        type: "nav-item",
        icon: SidebarIcons.FinalEvaluationIcon,
      },
      {
        id: 279,
        uri: "/hr/Performance-Improvement",
        label: "Performance Improvement Plan",
        type: "nav-item",
        icon: SidebarIcons.PerformanceImprovementIcon,
      },
    ],
  },

  {
    id: 18,
    label: "Training & Development",
    type: "collapsible",
    icon: SidebarIcons.TrainingIcon,
    children: [
      {
        id: 280,
        uri: "/hr/Training_Details",
        label: "Training Details",
        type: "nav-item",
        icon: SidebarIcons.TrainingDetailsIcon,
      },
      {
        id: 281,
        uri: "/hr/Trainer_Info",
        label: "Trainer Information",
        type: "nav-item",
        icon: SidebarIcons.TrainerInformationIcon,
      },
      {
        id: 282,
        uri: "/hr/Training_Schedule",
        label: "Training Schedule",
        type: "nav-item",
        icon: SidebarIcons.TrainingScheduleIcon,
      },
      {
        id: 283,
        uri: "/hr/Target_Audience",
        label: "Target Audience",
        type: "nav-item",
        icon: SidebarIcons.TargetAudienceIcon,
      },
      {
        id: 284,
        uri: "/hr/Training_Content",
        label: "Training Content",
        type: "nav-item",
        icon: SidebarIcons.TrainingContentIcon,
      },
      {
        id: 285,
        uri: "/hr/Training_Attendance",
        label: "Attendance & Completion",
        type: "nav-item",
        icon: SidebarIcons.TrainingAttendanceIcon,
      },
      {
        id: 286,
        uri: "/hr/Feedback",
        label: "Feedback & Effectiveness",
        type: "nav-item",
        icon: SidebarIcons.TrainingFeedbackIcon,
      },

      {
        id: 287,
        uri: "/hr/Budget",
        label: "Cost & Budget",
        type: "nav-item",
        icon: SidebarIcons.TrainingBudgetIcon,
      },
    ],
  },

  {
    id: 28,
    uri: "/hr/list-Reimbursement",
    label: "Reimbursement",
    type: "nav-item",
    icon: SidebarIcons.ReimbursementIcon,
  },

  {
    id: 28,
    uri: "/hr/EmployeeClaimsList",
    label: "Employee Claims",
    type: "nav-item",
    icon: SidebarIcons.ClaimIcon,
  },

  {
    id: 18,
    label: "Employee Exit",
    type: "collapsible",
    icon: SidebarIcons.EmployeeExitIcon,
    children: [
      {
        id: 248,
        uri: "/hr/list-Resignation",
        label: "Resignation",
        type: "nav-item",
        icon: SidebarIcons.ResignationIcon,
      },
      {
        id: 207,
        uri: "/hr/fullandfinal-settlement",
        label: "Full and Final Settlement",
        type: "nav-item",
        icon: SidebarIcons.FullandFinalIcon,
      },
    ],
  },

  {
    id: 18,
    label: "Reports",
    type: "collapsible",
    icon: SidebarIcons.ReportsIcon,
    children: [
      // {
      //   id: 193,
      //   uri: "/hr/HrOperation/DepartmentWiseChart",
      //   label: "Dashboard",
      //   type: "nav-item",
      //   icon: <FaUsersCog style={{ fontSize: 16, marginLeft: 15 }} />,
      // },
      {
        id: 194,
        uri: "/hr/HrOperation/EmployeeAdditionTrend",
        label: "Employee Addition Trend",
        type: "nav-item",
        icon: SidebarIcons.EmployeeAdditionIcon,
      },
      {
        id: 195,
        uri: "/hr/HrOperation/EmployeeAttritionTrend",
        label: "Employee Attrition Trend",
        type: "nav-item",
        icon: SidebarIcons.EmployeeAttritionIcon,
      },
      {
        id: 197,
        uri: "/hr/address",
        label: "Address Statement",
        type: "nav-item",
        icon: SidebarIcons.EmployeeAddressIcon,
      },
      {
        id: 196,
        uri: "/hr/esi",
        label: "ESI Statement",
        type: "nav-item",
        icon: SidebarIcons.ESIReportIcon,
      },
      {
        id: 200,
        uri: "/hr/pfreports",
        label: "PF Statement",
        type: "nav-item",
        icon: SidebarIcons.ESIReportIcon,
      },
      {
        id: 200,
        uri: "/hr/ProfessionalTaxReport",
        label: "PT Statement",
        type: "nav-item",
        icon: SidebarIcons.ESIReportIcon,
      },
      {
        id: 198,
        uri: "/hr/cashstatement",
        label: "Cash Statement",
        type: "nav-item",
        icon: SidebarIcons.CashStatementIcon,
      },
      {
        id: 288,
        uri: "/hr/bankstatement",
        label: "Bank Statement",
        type: "nav-item",
        icon: SidebarIcons.CashStatementIcon,
      },
      {
        id: 199,
        uri: "/hr/deduction",
        label: "Deduction Statement",
        type: "nav-item",
        icon: SidebarIcons.ESIReportIcon,
      },

      {
        id: 201,
        uri: "/hr/grosssalary",
        label: "GrossSalary Statement",
        type: "nav-item",
        icon: SidebarIcons.GrossSalaryIcon,
      },
      {
        id: 202,
        uri: "/hr/leavereport",
        label: "Leave Statement",
        type: "nav-item",
        icon: SidebarIcons.ESIReportIcon,
      },
      {
        id: 202,
        uri: "/hr/LeaveRegisterReport",
        label: "Leave Register Report",
        type: "nav-item",
        icon: SidebarIcons.ESIReportIcon,
      },
      {
        id: 203,
        uri: "/hr/attendancereport",
        label: "Attendance Summary",
        type: "nav-item",
        icon: SidebarIcons.ESIReportIcon,
      },
      {
        id: 289,
        uri: "/hr/AttendanceDetails",
        label: "Attendance Details",
        type: "nav-item",
        icon: SidebarIcons.ESIReportIcon,
      },
      {
        id: 290,
        uri: "/hr/AbsentStatement",
        label: "Absent Statement",
        type: "nav-item",
        icon: SidebarIcons.ESIReportIcon,
      },
      {
        id: 291,
        uri: "/hr/AttendanceForm",
        label: "Attendance Form",
        type: "nav-item",
        icon: SidebarIcons.ESIReportIcon,
      },
      {
        id: 292,
        uri: "/hr/TimesheetStatement",
        label: "Timesheet Statement",
        type: "nav-item",
        icon: SidebarIcons.ESIReportIcon,
      },
      {
        id: 204,
        uri: "/hr/employeereport",
        label: "Employee Report",
        type: "nav-item",
        icon: SidebarIcons.ESIReportIcon,
      },
      {
        id: 205,
        uri: "/hr/employeemaster",
        label: "Employee Allowance Report",
        type: "nav-item",
        icon: SidebarIcons.ESIReportIcon,
      },
      {
        id: 293,
        uri: "/hr/PayrollStatement",
        label: "Payslip Statement",
        type: "nav-item",
        icon: SidebarIcons.ESIReportIcon,
      },
      {
        id: 206,
        uri: "/hr/earning",
        label: "Earning and Deduction Summary",
        type: "nav-item",
        icon: SidebarIcons.ESIReportIcon,
      },
      {
        id: 294,
        uri: "/hr/MonthlyIncomeTaxReport",
        label: "Income Tax Statement",
        type: "nav-item",
        icon: SidebarIcons.ESIReportIcon,
      },
      {
        id: 295,
        uri: "/hr/Form3AReport",
        label: "Form3A",
        type: "nav-item",
        icon: SidebarIcons.ESIReportIcon,
      },
      {
        id: 296,
        uri: "/hr/Form6AReport",
        label: "Form6A",
        type: "nav-item",
        icon: SidebarIcons.ESIReportIcon,
      },
      {
        id: 297,
        uri: "/hr/Form16Report",
        label: "Form16",
        type: "nav-item",
        icon: SidebarIcons.ESIReportIcon,
      },
      {
        id: 298,
        uri: "/hr/Form16AReport",
        label: "Form16A",
        type: "nav-item",
        icon: SidebarIcons.ESIReportIcon,
      },
      {
        id: 299,
        uri: "/hr/AppraisalReports",
        label: "Appraisal Statement",
        type: "nav-item",
        icon: SidebarIcons.ESIReportIcon,
      },
      {
        id: 300,
        uri: "/hr/TrainingReports",
        label: "Training Statement",
        type: "nav-item",
        icon: SidebarIcons.ESIReportIcon,
      },
    ],
  },
];

// Function to filter menus based on user type
const getFilteredMenus = (userType) => {
  // if (userType === "Partner") {
  //   return hrmenus;
  // } else {
  //   return adminHrmenus;
  // }
  return adminHrmenus;
};

const Menu = ({ userType }) => {
  const filteredMenus = getFilteredMenus(userType);

  return (
    <div>
      {/* Render the filtered menus */}
      {filteredMenus?.map((menu) => (
        <div key={menu.label}>
          <div>{menu.label}</div>
          {menu.children?.map((subMenu) => (
            <div key={subMenu.label}>{subMenu.label}</div>
          ))}
        </div>
      ))}
    </div>
  );
};

Menu.propTypes = {
  userType: PropTypes.object,
};

export { Menu, adminHrmenus };
